import { EXPORT_ITEM, SET_EXPORT_LOADING_FLAG, GET_EXPORT_FILE } from './constants';

export function exportItem(callback, exportFromForms) {
  return {
    type: EXPORT_ITEM,
    callback,
    exportFromForms,
  };
}

export function setLoadingExportFlag(loading) {
  return {
    type: SET_EXPORT_LOADING_FLAG,
    loading,
  };
}

export function getFile(params, key, entityType, pollingAttempt = 0) {
  return {
    type: GET_EXPORT_FILE,
    key,
    params,
    entityType,
    pollingAttempt,
  };
}
